/**
 * Creates a keyboard event handler with custom activation conditions
 * @param shouldActivate - Function that determines if the key should trigger activation
 * @param callback - Function to call when activation condition is met
 * @returns Keyboard event handler function
 */
const createKeyboardHandler = (shouldActivate, callback) => {
    return (e) => {
        if (shouldActivate(e)) {
            e.preventDefault(); // Prevent default behavior (like scrolling with space key)
            if (callback) {
                callback(e);
            }
            else {
                // Simulate a click event if no callback is provided
                e.target.click();
            }
        }
    };
};
/**
 * Simulates button-like keyboard behavior for Enter and Space keys.
 * Triggers the provided callback or simulates a click event on the target element.
 *
 * @param callback - Function to call when Enter or Space is pressed
 * @returns Keyboard event handler function
 */
const simulateButtonKeyboardBehavior = (callback) => {
    return createKeyboardHandler((e) => e.key === "Enter" || e.key === " " || e.code === "Space", callback);
};
const simulateButtonKeyboardBehaviorOmitSpace = (callback) => {
    return createKeyboardHandler((e) => e.key === "Enter", callback);
};

export { simulateButtonKeyboardBehavior, simulateButtonKeyboardBehaviorOmitSpace };
